import { DataExplorerDetailField } from "./DataExplorerDetailField";
import type { DataExplorerDetailSectionProps } from "./types";
import { cn, resolveDataExplorerValue } from "./utils";

export function DataExplorerDetailSection<TContext = unknown>({
  section,
  title = section?.title,
  fields = section?.fields,
  children,
  context,
  className,
  classNames,
  fieldClassNames,
}: DataExplorerDetailSectionProps<TContext>) {
  const resolvedClassNames = {
    ...section?.classNames,
    ...classNames,
  };
  const visibleFields = (fields || []).filter(
    (field) => !(resolveDataExplorerValue(field.hidden, context) ?? false),
  );
  const sectionChildren =
    children ??
    (typeof section?.children === "function"
      ? section.children(context as TContext)
      : section?.children);
  const hasContent = Boolean(sectionChildren) || visibleFields.length > 0;

  if (!hasContent || resolveDataExplorerValue(section?.hidden, context)) {
    return null;
  }

  return (
    <section
      className={cn(
        "border-b border-border pb-6 last:border-b-0 last:pb-0",
        resolvedClassNames.root,
        section?.className,
        className,
      )}
    >
      {title ? (
        <div
          className={cn(
            "mb-4 text-[15px] font-semibold text-foreground",
            resolvedClassNames.title,
          )}
        >
          {title}
        </div>
      ) : null}
      <div className={cn("space-y-4", resolvedClassNames.body)}>
        {sectionChildren}
        {visibleFields.map((field, index) => (
          <DataExplorerDetailField
            key={field.id || String(index)}
            field={field}
            context={context}
            classNames={fieldClassNames}
          />
        ))}
      </div>
    </section>
  );
}
